import { useState } from 'react';
import { MuseumDataType } from '@portalCommon/constants';
import { OptimizedImg } from '@commonPackage/components';
import cx from './index.module.less';

interface Props {
  dataSource: MuseumDataType[];
  className?: string;
}

export const HoverSwipeCard = (props: Props) => {
  const { dataSource, className } = props;
  const [curIdx, setCurIdx] = useState(0);

  return (
    <div className={cx(className, 'hover-swipe-container')}>
      <div className={cx('side-bar')}>
        <div className={cx('line')}>
          {dataSource.map((item, idx) => {
            return (
              <div
                key={`${idx}_${item.title}`}
                className={cx('side-bar-unit', { hover: curIdx === idx })}
                onMouseEnter={() => setCurIdx(idx)}>
                <div className={cx('title')}>{item.title}</div>
                <div className={cx('brief')}>{item.brief}</div>
              </div>
            );
          })}
        </div>
        <div className={cx('number')}>
          <div className={cx('count')}>{`0${curIdx + 1}`}</div>
          <div className={cx('sum')}>{`0${dataSource.length}`}</div>
        </div>
      </div>
      <OptimizedImg width={800} loading="lazy" src={dataSource[curIdx].imgSrc} className={cx('image')} />
    </div>
  );
};
